import
  React
from 'react';

import {
  Base
} from '@vodacom/web-common';

import
  styled
from 'styled-components';

const FooterStyled = styled(Base)`
  display: flex;
  width: 100%;
`;

export const Footer = () => {

  return (
    <FooterStyled>
    </FooterStyled>
  );
};
